let fp_hero_slider = ( function( $ ) {

	let $slider,
		$bg_slider,
		slide_speed = 3000;

	let _init = function() {
		$slider = $( '#fp-hero-slider .slider' );
		$bg_slider = $( '#fp-hero-bg-slider' );

		if ( $slider.length > 0 ) {
			_setup_sliders();
		}
	};

	let _setup_sliders = function() {
		$slider.slick( {
			arrows: true,
			prevArrow: '<div class="prev"><div></div></div>',
			nextArrow: '<div class="next"><div></div></div>',
			dots: false,
			autoplay: true,
			infinite: true,
			autoplayTimeout: slide_speed,
			speed: 200,
			appendArrows: $slider.closest( '.container' ).find( '.controls' ),
			asNavFor: '#fp-hero-bg-slider',
		} );

		$bg_slider.slick({
			dots: false,
			infinite: true,
			arrows: false,
			speed: 500,
			fade: true,
			cssEase: 'linear',
			asNavFor: '#fp-hero-slider-slides',
		});
	};

	$( document ).ready( _init );

} )( jQuery );

module.exports = fp_hero_slider;